import { FILES_ENDPOINT, PROJECTS_ENDPOINT } from "Constants";
import { baseApi } from "Services";
import {
  DuplicateCheckRequest,
  DuplicateCheckResponse,
  PackagesDuplicateCheckRequest,
  PackagesDuplicateCheckResponse,
} from "../types";

const filesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    filestreamDuplicateCheck: builder.query<
      DuplicateCheckResponse,
      DuplicateCheckRequest
    >({
      query: (queryArg) => ({
        url: `${FILES_ENDPOINT}/upload/duplicate-check`,
        params: {
          sha256: queryArg.sha256,
          group_id: queryArg.groupId,
        },
      }),
    }),
    packagesDuplicateCheck: builder.query<
      PackagesDuplicateCheckResponse,
      PackagesDuplicateCheckRequest
    >({
      query: (queryArg) => ({
        url: `${PROJECTS_ENDPOINT}/packages/${queryArg.packageId}/duplicate-check`,
        params: {
          package_id: queryArg.packageId,
          sha256: queryArg.sha256,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useFilestreamDuplicateCheckQuery,
  usePackagesDuplicateCheckQuery,
} = filesApi;
